import { IResponse, consumer } from "@bemap/utils"
import { CreditPayload, ITeam } from "@bemap/utils"

export const getPartners = async (): Promise<IResponse> => {
  let url = `/partners`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const getPartnerById = async (id: number): Promise<IResponse> => {
  let url = `/partners/${id}`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const getAnalystsByPartner = async (id: number): Promise<IResponse> => {
  let url = `/partners/${id}/analysts`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const getCreditHistory = async (id: number): Promise<IResponse> => {
  let url = `/credits/${id}/history`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function newPartner(payload: ITeam): Promise<IResponse> {
  // dados da requisição
  const url = `/partners`

  // request
  try {
    return await consumer('POST', url, payload)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const transformToPartner = async (id: number): Promise<IResponse> => {
  let url = `/partners/transform-to-partner`

  try {
    return await consumer('POST', url, { id })
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const updatePartner = async (payload: ITeam): Promise<IResponse> => {
  // dados da requisição
  const url = `/partners/${payload.id}`

  // request
  try {
    return await consumer('PATCH', url, payload)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function deletePartner(id: number): Promise<IResponse> {
  // dados da requisição
  const url = `/partners/${id}`

  // request
  try {
    return await consumer('DELETE', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function toggleStatus(active: boolean, TeamId: string): Promise<IResponse> {
  // dados da requisição
  const url = `/teams/${TeamId}`
  const body = {
    status: active ? 1 : 0,
  };

  // request
  try {
    return await consumer('PATCH', url, body)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function handleCredit(payload: CreditPayload, router: string): Promise<IResponse> {
  // dados da requisição
  const url = `/credits/${router}`

  // request
  try {
    return await consumer('POST', url, payload)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
} 